import React, { useRef, useEffect } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { publish } from '_ui-core-js/utilities/events.js';
import { CAR_ASSETS_IMAGE_BASE_URL } from '_ui-core-js/constants/config.js';
import { FALLBACK_THUMBNAIL_IMAGE } from '_ui-core-js/constants/defaults.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { RANGE_GTM_TRACKING_VALUES } from '../../../../../../range/ui/constants/analytics.js';

export function WheelOption(props) {

  const {
    wheel, 
    index, 
    block, 
    updateDisplayName, 
    active,
    modelName,
    baseModelName
  } = props;

  const tabRef = useRef();
  const imageUrl = wheel.assets ? `${CAR_ASSETS_IMAGE_BASE_URL}/${wheel.assets[0]['@filename']}` : `/resources/images/${FALLBACK_THUMBNAIL_IMAGE}`;

  function dispatchUpdateWheelsEvent(event, index) {
    event.stopPropagation();

    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
      componentName: baseModelName ? RANGE_GTM_TRACKING_VALUES.componentName.gradeRange + '-' + baseModelName : RANGE_GTM_TRACKING_VALUES.componentName.modelRange,
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: RANGE_GTM_TRACKING_VALUES.action.selectWheels + '-' + wheel.name,
      label: modelName
    })

    publish('kc-vehicle-configurator-update', { 
      option: 'wheels', 
      index
    });
  };

  useEffect(() => {
    if (active) {
      tabRef.current.focus();
      setTimeout(() => {
        tabRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }, 500);
    }
  }, [active]);

  return (
    <button 
    ref={tabRef}
    className={
      classNames({
        [`${block}__option-value-tab`]: true,
        [`${block}__option-value-tab--wheel`]: true,
        [`${block}__option-value-tab--active`]: active,
        [`${block}__option-value-tab--accessory-wheel`]: wheel.type === 'accessory',
        [`${block}__option-value-tab--disabled`]: !wheel.short
      })
    } 
    onClick={!wheel.short ? undefined : e => dispatchUpdateWheelsEvent(e, index)}
    onMouseEnter={() => updateDisplayName(index)} 
    onMouseLeave={updateDisplayName}
    > 
      <span className={`${block}__option-value-tab-inner`}>
        <img src={imageUrl} draggable='false' />
      </span>
    </button>
  )
};

WheelOption.propTypes = {
  wheel: propTypes.object.isRequired,
  index: propTypes.number.isRequired,
  block: propTypes.string.isRequired,
  updateDisplayName: propTypes.func.isRequired,
  modelName: propTypes.string,
  baseModelName: propTypes.string,
  active: propTypes.bool
};

WheelOption.defaultProps = {
  active: false
};